import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { DrugSearchURLService } from './drug-search-url.service';
import { ToastService } from './toast.service';

@Injectable({
    providedIn: 'root'
})
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(private _drugSearchURLService: DrugSearchURLService, public toastService: ToastService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((errorResponse) => {
                    let errorMsg = '';
                    if (errorResponse.status == 404) {
                        errorMsg = "Error processing request. Please contact support team";
                        this.toastService.show(errorMsg, {
                          classname: 'bg-danger text-light',
                          delay: 2000 ,
                          autohide: false,
                          headertext: 'Error!!!'
                        });
                    } else {
                        errorMsg = this._drugSearchURLService.messageKeyValueMap.get(errorResponse.error.code);
                        if (errorResponse.error.status !== 400) {
                          this.toastService.show(errorMsg, {
                            classname: 'bg-danger text-light',
                            delay: 2000 ,
                            autohide: false,
                            headertext: 'Error!!!'
                          });
                        }
                    }
                    return throwError(errorResponse);
                })
            )
    }
}
